import * as types from "../actionTypes";

export const managerGetPendingListRequest = () => {
  return {
    type: types.MANAGER_DASHBOARD_GET_PENDING_LIST_REQUEST
  };
};
export const managerGetPendingListSuccess = data => {
  return {
    type: types.MANAGER_DASHBOARD_GET_PENDING_LIST_SUCCESS,
    payLoad: data
  };
};
export const managerGetPendingListFailure = error => {
  return {
    type: types.MANAGER_DASHBOARD_GET_PENDING_LIST_FAILURE,
    error: error
  };
};

export const managerGetCustodianBalanceRequest = () => {
  return {
    type: types.MANAGER_DASHBOARD_GET_CUSTODIAN_BALANCE_REQUEST
  };
};
export const managerGetCustodianBalanceSuccess = data => {
  return {
    type: types.MANAGER_DASHBOARD_GET_CUSTODIAN_BALANCE_SUCCESS,
    payLoad: data
  };
};
export const managerGetCustodianBalanceFailure = error => {
  return {
    type: types.MANAGER_DASHBOARD_GET_CUSTODIAN_BALANCE_FAILURE,
    error: error
  };
};

export const managerGetClassificationRequest = () => {
  return {
    type: types.MANAGER_DASHBOARD_GET_CLASSIFICATION_REQUEST
  };
};
export const managerGetClassificationSuccess = data => {
  return {
    type: types.MANAGER_DASHBOARD_GET_CLASSIFICATION_SUCCESS,
    payLoad: data
  };
};
export const managerGetClassificationFailure = error => {
  return {
    type: types.MANAGER_DASHBOARD_GET_CLASSIFICATION_FAILURE,
    error: error
  };
};
